//@flow
export const FETCH_NOTIFICATIONS_REQUEST = 'FETCH_NOTIFICATIONS_REQUEST'
export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS'
export const FETCH_NOTIFICATIONS_FAIL = 'FETCH_NOTIFICATIONS_FAIL'
export const SAVE_NOTIFICATION = 'SAVE_NOTIFICATION'

export const DISMISS_NOTIFICATION_REQUEST = 'DISMISS_NOTIFICATION_REQUEST'
export const DISMISS_NOTIFICATION_SUCCESS = 'DISMISS_NOTIFICATION_SUCCESS'
export const DISMISS_NOTIFICATION_FAIL = 'DISMISS_NOTIFICATION_FAIL'

export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS'

export const ALL_NOTIFICATIONS = 'notifications'

// see backend/models/notification for values
export const NOTIFICATION_TYPE = {
  // user related 0-9
  USER_REGISTERED: 1,
  USER_EMAIL_CONFIRMED: 2,
  // charity related 10-19
  CHARITY_REGISTERED: 10,
  CHARITY_CONNECTED_ACOUNT: 11,
  // saved event/item 20-29
  SAVED_EVENT: 20, //only used in the app internally (no backend)
  SAVED_ITEM: 21, //only used in the app internally (no backend)
  SAVED_EVENT_START: 22,
  SAVED_ITEM_START: 23,
  // bids 30-39
  BID_OUTBID: 30,
  BID_WINNING: 31,
  // auctions 40-49
  AUCTION_RESULT_WON: 40,
  AUCTION_RESULT_LOST: 41,
  // checkout 50-59
  CHECKOUT_CREATED: 50,
  CHECKOUT_COMPLETED: 51,
  CHECKOUT_ALMOST_EXPIRED: 52,
  CHECKOUT_EXPIRED: 53,
  // payments 60-69
  CHECKOUT_ITEM_PAYMENT_OK: 60,
  CHECKOUT_ITEM_PAYMENT_FAILED: 61
}



// WEBPACK FOOTER //
// ./src/services/notification/constants.js